import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HeaderComponent } from "./components/header/header.component";
import { PrimeNG } from 'primeng/config';
import { FilterMatchMode } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { FooterModule } from "./components/footer/footer.component";
import { TranslateService } from '@ngx-translate/core';
import * as CookieConsent from 'vanilla-cookieconsent';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    HeaderComponent,
    CommonModule,
    RouterOutlet,
    FormsModule,
    FooterModule
  ]
})
export class AppComponent implements OnInit, AfterViewInit {

  constructor(private primeng: PrimeNG, private translateService: TranslateService) {}

  ngAfterViewInit(): void{
    CookieConsent.run({
      categories: {
        necessary: {
            enabled: true,  // this category is enabled by default
            readOnly: true  // this category cannot be disabled
        },
        analytics: {},
        advertising: {}
    },
    
    language: {
        default: 'nl',
        translations: {
          nl: {
            consentModal: {
              title: 'Wij maken gebruik van cookies',
              description: 'Onze website maakt gebruik van cookies. De essentiële en functionele cookies zijn nodig voor het goed functioneren van de website en kunnen niet worden geweigerd. Andere cookies worden gebruikt voor statistische doeleinden (analytische cookies) om informatie te verzamelen over hoe u en anderen onze website gebruiken. Wij maken ook gebruik van sociale media plugins, waarvoor ook cookies worden gebruikt. Voor alle niet-essentiële of niet-functionele cookies vragen wij steeds uw toestemming alvorens deze te plaatsen. U kan uw keuze hieronder meedelen. Als u hier eerst meer informatie over wilt, verwijzen wij u door naar onze <a href="/cookiepolicy">cookieverklaring.</a>',
              acceptAllBtn: 'Alle cookies aanvaarden',
              acceptNecessaryBtn: 'Alle cookies weigeren',
              showPreferencesBtn: 'Voorkeuren instellen'
            },
            preferencesModal: {
              title: 'Cookievoorkeuren beheren',
              acceptAllBtn: 'Alles accepteren',
              acceptNecessaryBtn: 'Alles weigeren',
              savePreferencesBtn: 'Huidige selectie accepteren',
              closeIconLabel: 'Venster sluiten',
              sections: [
                {
                  title: 'Essentiële en noodzakelijke cookies',
                  description: 'Stellen u in staat om door de website te navigeren en de essentiële functies ervan te gebruiken. De cookies maken het mogelijk een dienst of functionaliteit te leveren waar de gebruiker uitdrukkelijk om heeft gevraagd. Deze cookies kunnen zonder uw toestemming worden geplaatst. We raden u dan ook aan deze cookies niet uit te schakelen omdat dit ervoor kan zorgen dat de basisfunctionaliteiten of de toegang tot bepaalde delen van de website worden verstoord.',
                  linkedCategory: 'necessary'
                },
                {
                  title: 'Analytische cookies',
                  description: 'Deze cookies zorgen voor informatie over hoe en wanneer je de website gebruikt. Zo kunnen we bijvoorbeeld zien hoe vaak een bepaalde pagina wordt gelezen. Deze informatie gebruiken we enkel om onze website te verbeteren en gebruiksvriendelijker te maken. Het weigeren van deze cookies heeft geen invloed op het gebruik en de functionaliteit van de website.',
                  linkedCategory: 'analytics'
                },
                {
                  title: 'Advertentie cookies',
                  description: 'Deze cookies zorgen ervoor dat derde partijen informtaie krijgen over je bezoek aan onze website en verzamelen informatie over je surfgedrag op onze website. Derde partijen kunnen dit combineren met andere informatie die jij hen gegeven hebt of die zij hebben verzameld op basis van het gebruik van hun diensten, met als doel om jou relevante advertenties te tonen op andere websites of sociale media.',
                  linkedCategory: 'advertising'
                }
              ]
            }
          }
        }
    }
    });
}

  ngOnInit() {
      this.primeng.zIndex = {
          modal: 1100,    // dialog, sidebar
          overlay: 1000,  // dropdown, overlaypanel
          menu: 1000,     // overlay menus
          tooltip: 1100   // tooltip
      };
      this.primeng.filterMatchModeOptions = {
        text: [FilterMatchMode.STARTS_WITH, FilterMatchMode.CONTAINS, FilterMatchMode.NOT_CONTAINS, FilterMatchMode.ENDS_WITH, FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS],
        numeric: [FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS, FilterMatchMode.LESS_THAN, FilterMatchMode.LESS_THAN_OR_EQUAL_TO, FilterMatchMode.GREATER_THAN, FilterMatchMode.GREATER_THAN_OR_EQUAL_TO],
        date: [FilterMatchMode.DATE_IS, FilterMatchMode.DATE_IS_NOT, FilterMatchMode.DATE_BEFORE, FilterMatchMode.DATE_AFTER]
    };

    this.translateService.setDefaultLang('nl');
    this.translate('nl');
  }

  translate(lang: string) {
    this.translateService.use(lang);
    this.translateService.get('primeng').subscribe(res => this.primeng.setTranslation(res));
  }
}
